import { lazy } from 'react';
import MainLayout from './components/layouts/MainLayout';
import Loadable from './components/ui/Loadable';
import { Navigate } from 'react-router-dom';
import AuthGuard from './components/Guards/AuthGuard/AuthGuard';
import PermissionGaurd, { PermissionRights } from './components/Guards/PermissionGuard/PermissionGuard';
import { PermissionCodes } from './utils/constants';
import DivisionGaurd from './components/Guards/DivisionGuard/DivisionGuard';
import { Divisions } from './utils/constants/Divisions.Constants';
import SampleSubmission from './pages/sampleSubmissions/SampleSubmissionSearch';
import CylinderSearch from './pages/cylinders/CylinderSearch';
import IF from './components/ui/IF';
import { useIsDivisionAssigned } from './hooks/useIsDivisionAssigned';
import CountrySearch from './pages/CountrySearch/CountrySearch';
import CountryEdit from './pages/CountrySearch/CountryEdit';
// import SamplePage from './pages/samples/samplePage';
// import CountriesSearch from './pages/Countries/Countries';
// import RoleAddEditPetroHub from './pages/administrator/role/RoleAddEditPetroHub';
// import RoleSearchPetroHub from './pages/administrator/role/RoleSearchPetroHub';

function RoleSearchSwitch() {
  const isAssigned = useIsDivisionAssigned(Divisions.MaxxLIMs);
  return (
    <>
      <IF condition={isAssigned}>
        <RoleSearchPetroHub />
      </IF>
      <IF condition={!isAssigned}>
        <RoleSearch />
      </IF>
    </>
  );
}

function RoleAddSwitch() {
  const isAssigned = useIsDivisionAssigned(Divisions.MaxxLIMs);
  // console.log('isAssigned for RoleAddSwitch: ', isAssigned);
  return (
    <>
      <IF condition={isAssigned}>
        <RoleAddEditPetroHub />
      </IF>
      <IF condition={!isAssigned}>
        <RoleCreate />
      </IF>
    </>
  );
}

function RoleEditSwitch() {
  const isAssigned = useIsDivisionAssigned(Divisions.MaxxLIMs);
  // console.log('isAssigned for RoleEditSwitch: ', isAssigned);
  return (
    <>
      <IF condition={isAssigned}>
        <RoleAddEditPetroHub />
      </IF>
      <IF condition={!isAssigned}>
        <RoleEdit />
      </IF>
    </>
  );
}

const DivisionSwitch = Loadable(
  lazy(() => import('./components/DivisionSwitch/DivisionSwitch'))
);
// - Authentication pages

const Login = Loadable(lazy(() => import('./pages/auth/Login')));
// const LoginPetroHub = Loadable(lazy(() => import('./pages/auth/Login')));
const ClientPassword = Loadable(
  lazy(() => import('./pages/auth/ClientPassword'))
);
const ForgotPassword = Loadable(
  lazy(() => import('./pages/auth/ForgotPassword'))
);

// - Admin Pages
const UserSearch = Loadable(
  lazy(() => import('./pages/administrator/user/UserSearch'))
);
const UserEdit = Loadable(
  lazy(() => import('./pages/administrator/user/UserEdit'))
);
// const UserEditOP = Loadable(
//   lazy(() => import('./pages/administrator/user/UserEditOP'))
// );
const UserCreate = Loadable(
  lazy(() => import('./pages/administrator/user/UserCreate'))
);

const RoleSearch = Loadable(
  lazy(() => import('./pages/administrator/role/RoleSearch'))
);
const RoleSearchPetroHub = Loadable(
  lazy(() => import('./pages/administrator/role/RoleSearchPetroHub'))
);
const RoleCreate = Loadable(
  lazy(() => import('./pages/administrator/role/RoleCreate'))
);
const RoleEdit = Loadable(
  lazy(() => import('./pages/administrator/role/RoleEdit'))
);
const RoleAddEditPetroHub = Loadable(
  lazy(() => import('./pages/administrator/role/RoleAddEditPetroHub'))
);
const NewsSearch = Loadable(
  lazy(() => import('./pages/administrator/news/NewsSearch'))
);
const NewsCreate = Loadable(
  lazy(() => import('./pages/administrator/news/NewsCreate'))
);
const NewsEdit = Loadable(
  lazy(() => import('./pages/administrator/news/NewsEdit'))
);
const TimeStampEvents = Loadable(
  lazy(() => import('./pages/TimestampEvent/TimeStampEventSearch'))
);
const DocumentSearch = Loadable(
  lazy(() => import('./pages/administrator/document/DocumentSearch'))
);
const DocumentCreate = Loadable(
  lazy(() => import('./pages/administrator/document/DocumentCreate'))
);
const DocumentEdit = Loadable(
  lazy(() => import('./pages/administrator/document/DocumentEdit'))
);

const ClientQuotes = Loadable(
  lazy(() => import('./pages/clientQuotes/clientQuotes'))
);
const ClientQuotesAddEditForm = Loadable(
  lazy(() =>
    import(
      './pages/clientQuotes/components/ClientQuotesAddEditForm/ClientQuotesAddEditForm'
    ))
);
const SampleSubmissionsSearch = Loadable(
  lazy(() => import('./pages/sampleSubmissions/SampleSubmissionSearch'))
);
const SampleSubmissionAddEditForm = Loadable(
  lazy(() =>
    import(
      './pages/sampleSubmissions/components/SampleSubmissionAddForm/SampleSubmissionAddForm'
    ))
);

const TranslationSets = Loadable(
  lazy(() => import('./pages/translationSets/translationSets'))
);

const TranslationSetsEditForm = Loadable(
  lazy(() =>
    import(
      './pages/translationSets/components/TranslationSetEditForm/TranslationSetEditForm'
    ))
);

const Target = Loadable(lazy(() => import('./pages/target/TargetSearch')));

const Statistics = Loadable(lazy(() => import('./pages/Statistics/StatisticsSearch')));

const TargetEditForm = Loadable(
  lazy(() =>
    import(
      './pages/target/components/TargetEditForm/TargetEditForm'
    ))
);

const DataSchemaSearch = Loadable(
  lazy(() => import('./pages/dataSchema/DataSchemaSearch'))
);
const DataSchemaSearchEditForm = Loadable(
  lazy(() =>
    import(
      './pages/dataSchema/components/DataSchemaSearchEditForm/DataSchemaSearchEditForm'
    ))
);

const APILogSearch = Loadable(
  lazy(() => import('./pages/APILog/APILogSearch'))
);

const OutboundSearch = Loadable(
  lazy(() => import('./pages/Outbound/OutboundSearch'))
);

const KnowledgeCenter = Loadable(
  lazy(() => import('./pages/knowledgeCenter/KnowledgeCenter'))
);

const NotificationSetting = Loadable(
  lazy(() => import('./pages/notificationSetting/NotificationSetting'))
);

// const CreateUser = Loadable(lazy(() => import('../pages/administrator/user/CreateUser')));

// - Dashboard

// const Overview = Loadable(lazy(() => import('./pages/dashboard/Overview')));
const MineralDashboard = Loadable(
  lazy(() => import('./pages/dashboard/MineralDashboard'))
);
const FoodDashboard = Loadable(
  lazy(() => import('./pages/dashboard/FoodDashboard'))
);
const FQTDashboard = Loadable(
  lazy(() => import('./pages/dashboard/FQTDashboard'))
);
const BVAQDashboard = Loadable(
  lazy(() => import('./pages/dashboard/BVAQDashboard'))
);
const OPDashboard = Loadable(
  lazy(() => import('./pages/dashboard/OPDashboard'))
);

// Job Pages
const JobSearch = Loadable(lazy(() => import('./pages/jobs/JobSearch')));
const JobDetails = Loadable(lazy(() => import('./pages/jobs/JobDetails')));

const TimeLogCalculationSearch = Loadable(lazy(() => import('./pages/TimeLogCalculation/TimeLogCalculationSearch')));
const TimeLogCalculationAddEditForm = Loadable(lazy(() => import('./pages/TimeLogCalculation/components/TimeLogCalculationAddEditForm/TimeLogCalculationAddEditForm')));

const QuantityDisplayGroupSearch = Loadable(lazy(() => import('./pages/QuantityDisplayGroup/QuantityDisplayGroupSearch')));
// Feedback Pages
const FeedbackSearch = Loadable(
  lazy(() => import('./pages/feedback/FeedbackSearch'))
);

// Sample Pages
// const SampleSearch = Loadable(
//   lazy(() => import('./pages/samples/SampleSearch'))
// );

// const SampleDetails = Loadable(
//   lazy(() => import('./pages/samples/SampleDetails'))
// );

const SamplePage = Loadable(
  lazy(() => import('./pages/samples/SamplePage'))
);

const SampleDetailsPage = Loadable(
  lazy(() => import('./pages/samples/SampleDetailsPage'))
);

// Sample Tracking Page
const SampleTrackingSearch = Loadable(
  lazy(() => import('./pages/SampleTracking/SampleTrackingSearch'))
);
// const SampleTrackingDetails = Loadable(
//   lazy(() => import('./pages/SampleTracking/SampleTrackingDetails'))
// );

// Report Pages
const ReportSearch = Loadable(
  lazy(() => import('./pages/reports/ReportSearch'))
);

// Export Page
const Export = Loadable(
  lazy(() => import('./pages/export/Export'))
);

// Invoice Pages
const InvoiceSearch = Loadable(
  lazy(() => import('./pages/invoice/InvoiceSearch'))
);
const InvoiceDetails = Loadable(
  lazy(() => import('./pages/invoice/InvoiceDetails'))
);

const ObjectConfigurationSearch = Loadable(
  lazy(() => import('./pages/objectConfiguration/ObjectConfigurationSearch'))
);
const ObjectConfigAddEditForm = Loadable(
  lazy(() =>
    import(
      './pages/objectConfiguration/components/ObjectConfigAddEditForm/ObjectConfigAddEditForm'
    ))
);

// Inspection Location Add/Edit page
const InspectionLocationAddEdit = Loadable(
  lazy(() => import('./pages/InspectionLocation/components/InspectionLocationAddEditForm/InspectionLocationAddEditForm'))
);

// Error pages
const AuthorizationError = Loadable(
  lazy(() => import('./pages/error/AuthorizationError'))
);

const NotFound = Loadable(lazy(() => import('./pages/error/NotFound')));
const ServerError = Loadable(lazy(() => import('./pages/error/ServerError')));

const LegalNotice = Loadable(lazy(() => import('./pages/privacy/LegalNotice')));
const CookiesPolicy = Loadable(
  lazy(() => import('./pages/privacy/CookiesPolicy'))
);
const TermsOfUse = Loadable(lazy(() => import('./pages/privacy/TermsOfUse')));
const InformationNoticeToUser = Loadable(
  lazy(() => import('./pages/privacy/InformationNoticeToUser'))
);

// Notifications
const AccountSetting = Loadable(
  lazy(() => import('./pages/AccountSetting/AccountSetting'))
);

// Experiment Feautures
const ExperimentFeature = Loadable(
  lazy(() => import('./pages/ExperimentFeature/ExperimentFeature'))
);

// Analysis Pages
const TrendingView = Loadable(
  lazy(() => import('./pages/Analysis/TrendingView'))
);

// Sample Alerts Search
const SampleAlertSearch = Loadable(
  lazy(() => import('./pages/SampleAlert/SampleAlertSearch'))
);

const SubscriptionSearch = Loadable(
  lazy(() => import('./pages/subscriptions/SubscriptionSearch'))
);
const SubscriptionSearchEditForm = Loadable(
  lazy(() =>
    import(
      './pages/subscriptions/components/SubscriptionSearchEditForm/SubscriptionSearchEditForm'
    ))
);

const UserGroupSearch = Loadable(
  lazy(() => import('./pages/userGroups/userGroupSearch'))
);
const UserGroupDetails = Loadable(lazy(() => import('./pages/userGroups/UserGroupDetails')));

// - My Actions
const MyActions = Loadable(
  lazy(() => import('./pages/MyActions/MyActions'))
);

// Actions Pages
const ActionsSearch = Loadable(
  lazy(() => import('./pages/Actions/ActionsSearch'))
);

const AssetManagement = Loadable(
  lazy(() => import('./pages/assetManagement/AssetManagement'))
);

const InspectionLocationSearch = Loadable(
  lazy(() => import('./pages/InspectionLocation/InspectionLocationSearch'))
);

const Equipments = Loadable(
  lazy(() => import('./pages/Equipments/Equipments'))
);

const Locations = Loadable(
  lazy(() => import('./pages/locations/Locations'))
);

// Client Page
// const ClientSearch = Loadable(
//   lazy(() => import('./pages/clients/ClientSearch'))
// );
const ClientPage = Loadable(
  lazy(() => import('./pages/clients/ClientPage'))
);
// const PetrohubClientSearch = Loadable(
//   lazy(() => import('./pages/clients/PetrohubClients/PetrohubClientSearch'))
// );
const PetrohubClientEdit = Loadable(
  lazy(() => import('./pages/clients/PetrohubClients/components/ClientEdit'))
);

// Timestamp Event Page
const TimestampEventAddEdit = Loadable(
  lazy(() => import('./pages/TimestampEvent/components/TimestampEventAddEdit/TimestampEventAddEdit'))
);

// ConsumableOrders Page

const ConsumableOrdersSearch = Loadable(
  lazy(() => import('./pages/consumableOrders/ConsumableOrdersSearch'))
);

const ConsumableOrderEdit = Loadable(
  lazy(() => import('./pages/consumableOrders/components/ConsumableOrderEdit/ConsumableOrderEdit'))
);
const ConsumableOrderAdd = Loadable(
  lazy(() => import('./pages/consumableOrders/components/ConsumableOrderAdd/ConsumableOrderAdd'))
);
const OrderSearch = Loadable(
  lazy(() => import('./pages/Orders/OrderSearch'))
);
const OrderView = Loadable(
  lazy(() => import('./pages/Orders/components/OrderView'))
);
const OrderRequestSearch = Loadable(
  lazy(() => import('./pages/OrderRequest/OrderRequestSearch'))
);
const OrderRequestAdd = Loadable(
  lazy(() => import('./pages/OrderRequest/components/OrderRequestAdd'))
);
const OrderRequestView = Loadable(
  lazy(() => import('./pages/OrderRequest/components/OrderRequestView'))
);
const OrderRequestEdit = Loadable(
  lazy(() => import('./pages/OrderRequest/components/OrderRequestAdd'))
);
// MarineFuel - AboutUs

const AboutUs = Loadable(
  lazy(() => import('./pages/AboutUs/AboutUs'))
);

const routes = [
  // {
  //   path: 'auth',
  //   children: [
  //     {
  //       path: 'login',
  //       element: <Login />,
  //     },
  //   ],
  // },
  {
    path: 'admin',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: 'users',
        children: [
          {
            path: '',
            element: (
              <PermissionGaurd permission={PermissionCodes.UserManagement} right={PermissionRights.Search}>
                <UserSearch />
              </PermissionGaurd>
            ),
          },
          {
            path: ':userId',
            element: (
              <PermissionGaurd permission={PermissionCodes.UserManagement} right={PermissionRights.Edit}>
                <UserEdit />
              </PermissionGaurd>
            ),
          },
          // {
          //   path: 'OP/:userId',
          //   element: (
          //     <PermissionGaurd permission={PermissionCodes.UserManagement}>
          //       <UserEditOP />
          //     </PermissionGaurd>
          //   ),
          // },
          {
            path: 'create',
            element: (
              <PermissionGaurd permission={PermissionCodes.UserManagement} right={PermissionRights.Add}>
                <UserCreate />
              </PermissionGaurd>
            ),
          },
        ],
      },
      {
        path: 'roles',
        element: (
          <PermissionGaurd permission={PermissionCodes.RoleManagement} right={PermissionRights.Search}>
            <RoleSearchSwitch />
          </PermissionGaurd>
        ),
      },
      {
        path: 'roles/add',
        element: (
          <PermissionGaurd permission={PermissionCodes.RoleManagement} right={PermissionRights.Add}>
            <RoleAddSwitch />
          </PermissionGaurd>
        ),
      },
      {
        path: 'roles/:roleId/edit',
        element: (
          <PermissionGaurd permission={PermissionCodes.RoleManagement} right={PermissionRights.Edit}>
            <RoleEditSwitch />
          </PermissionGaurd>
        ),
      },
      {
        path: 'news',
        element: (
          <PermissionGaurd permission={PermissionCodes.NewsManagement} right={PermissionRights.Search}>
            <NewsSearch />
          </PermissionGaurd>
        ),
      },
      {
        path: 'news/add',
        element: (
          <PermissionGaurd permission={PermissionCodes.NewsManagement} right={PermissionRights.Add}>
            <NewsCreate />
          </PermissionGaurd>
        ),
      },
      {
        path: 'news/:newsId/edit',
        element: (
          <PermissionGaurd permission={PermissionCodes.NewsManagement} right={PermissionRights.Edit}>
            <NewsEdit />
          </PermissionGaurd>
        ),
      },
      {
        path: 'documents',
        element: (
          <PermissionGaurd permission={PermissionCodes.DocumentManagement} right={PermissionRights.Search}>
            <DocumentSearch />
          </PermissionGaurd>
        ),
      },
      {
        path: 'documents/add',
        element: (
          <PermissionGaurd permission={PermissionCodes.DocumentManagement} right={PermissionRights.Add}>
            <DocumentCreate />
          </PermissionGaurd>
        ),
      },
      {
        path: 'documents/:documentId/edit',
        element: (
          <PermissionGaurd permission={PermissionCodes.DocumentManagement} right={PermissionRights.Edit}>
            <DocumentEdit />
          </PermissionGaurd>
        ),
      },
      {
        path: 'feedback',
        element: (
          <PermissionGaurd permission={PermissionCodes.FeedbackManagement} right={PermissionRights.Edit}>
            <FeedbackSearch />
          </PermissionGaurd>
        ),
      },
    ],
  },
  {
    path: 'jobs',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <PermissionGaurd permission={PermissionCodes.Jobs}>
            <JobSearch />
          </PermissionGaurd>
        ),
      },
      {
        path: ':jobId',
        element: (
          <PermissionGaurd permission={PermissionCodes.Jobs}>
            <JobDetails />
          </PermissionGaurd>
        ),
      },
    ],
  },
  {
    path: 'Cylinders',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <PermissionGaurd permission={PermissionCodes.Cylinder} right={PermissionRights.Search}>
            <CylinderSearch />
          </PermissionGaurd>
        ),
      },
    ],
  },
  {
    path: 'timeLogCalculation',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <PermissionGaurd permission={PermissionCodes.TimeLogCalculation}>
            <TimeLogCalculationSearch />
          </PermissionGaurd>

        ),
      }, {
        path: ':add',
        element: (
          <PermissionGaurd permission={PermissionCodes.TimeLogCalculation}>
            <TimeLogCalculationAddEditForm />
          </PermissionGaurd>

        ),
      },
      {
        path: ':id/edit',
        element: (
          <PermissionGaurd permission={PermissionCodes.TimeLogCalculation}>
            <TimeLogCalculationAddEditForm />
          </PermissionGaurd>
        ),
      },
    ],
  },
  {
    path: 'quantityDisplayGroup',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <PermissionGaurd permission={PermissionCodes.QuantityDisplayGroup}>
            <QuantityDisplayGroupSearch />
          </PermissionGaurd>

        ),
      },
    ],
  },
  {
    path: 'samples',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <PermissionGaurd permission={PermissionCodes.Samples} right={PermissionRights.Search}>
            {/* <SampleSearch /> */}
            <SamplePage />
          </PermissionGaurd>
        ),
      },
      {
        path: ':sampleId',
        element: (
          <PermissionGaurd permission={PermissionCodes.Samples} right={PermissionRights.Search}>
            {/* <SampleDetails /> */}
            <SampleDetailsPage />
          </PermissionGaurd>
        ),
      },
    ],
  },
  {
    path: 'sampletracking',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <DivisionGaurd divisionId={Divisions.Verifuel}>
            <PermissionGaurd permission={PermissionCodes.SampleTracking}>
              <SampleTrackingSearch />
            </PermissionGaurd>
          </DivisionGaurd>
        ),
      },
      // {
      //   path: ':sampleIdText',
      //   element: (
      //     <PermissionGuard permission={PermissionCodes.SampleTracking}>
      //       <SampleDetails />
      //     </PermissionGuard>
      //   ),
      // },
    ],
  },
  {
    path: 'timestampEvents',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <PermissionGaurd permission={PermissionCodes.TimestampEvent}>
            <TimeStampEvents />
          </PermissionGaurd>
        ),
      }, {
        path: 'add',
        element: (
          <PermissionGaurd permission={PermissionCodes.TimestampEvent}>
            <TimestampEventAddEdit />
          </PermissionGaurd>
        ),
      },
      {
        path: ':id/edit',
        element: (
          <PermissionGaurd permission={PermissionCodes.TimestampEvent}>
            <TimestampEventAddEdit />
          </PermissionGaurd>
        ),
      },
    ],
  },
  {
    path: 'sampleSubmissions',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <PermissionGaurd permission={PermissionCodes.Samples}>
            <SampleSubmissionsSearch />
          </PermissionGaurd>
        ),
      },
      {
        path: 'add',
        element: (
          <PermissionGaurd permission={PermissionCodes.Samples}>
            <SampleSubmissionAddEditForm />
          </PermissionGaurd>
        ),
      },
      {
        path: 'add/:templateId',
        element: (
          <PermissionGaurd permission={PermissionCodes.Samples}>
            <SampleSubmissionAddEditForm />
          </PermissionGaurd>
        ),
      },
      {
        path: ':id/edit',
        element: (
          <PermissionGaurd permission={PermissionCodes.Samples}>
            <SampleSubmissionAddEditForm />
          </PermissionGaurd>
        ),
      },
      {
        path: '',
        element: (
          <PermissionGaurd permission={PermissionCodes.SampleSubmissions}>
            <SampleSubmission />
          </PermissionGaurd>
        ),
      },
    ],
  },
  {
    path: 'statistics',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <PermissionGaurd permission={PermissionCodes.Statistics}>
            <Statistics />
          </PermissionGaurd>
        ),
      },
    ],
  },
  {
    path: 'target',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <PermissionGaurd permission={PermissionCodes.Targets}>
            <Target />
          </PermissionGaurd>
        ),
      },
      {
        path: ':id/edit',
        element: (
          // <PermissionGuard permission={PermissionCodes.TranslationSets}>
          <TargetEditForm />
          // </PermissionGuard>
        ),
      },
    ],
  },
  {
    path: 'reports',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <PermissionGaurd permission={PermissionCodes.Reports}>
            <ReportSearch />
          </PermissionGaurd>
        ),
      },
    ],
  },
  {
    path: 'export',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <PermissionGaurd permission={PermissionCodes.ExportData}>
            <Export />
          </PermissionGaurd>
        ),
      },
    ],
  },
  {
    path: 'NotificationTemplates',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <PermissionGaurd
            permission={PermissionCodes.NotificationTemplateSettings} right={PermissionRights.Edit}
          >
            <NotificationSetting />
          </PermissionGaurd>
        ),
      },
      {
        path: ':triggerId',
        element: (
          <PermissionGaurd
            permission={PermissionCodes.NotificationTemplateSettings} right={PermissionRights.Edit}
          >
            <NotificationSetting />
          </PermissionGaurd>
        ),
      },
      {
        path: ':triggerId/:templateId',
        element: (
          <PermissionGaurd
            permission={PermissionCodes.NotificationTemplateSettings} right={PermissionRights.Edit}
          >
            <NotificationSetting />
          </PermissionGaurd>
        ),
      },
    ],
  },
  {
    path: 'invoices',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <PermissionGaurd permission={PermissionCodes.InvoiceSearch}>
            <InvoiceSearch />
          </PermissionGaurd>
        ),
      },
      {
        path: ':invoiceId',
        element: (
          <PermissionGaurd permission={PermissionCodes.InvoiceSearch}>
            <InvoiceDetails />
          </PermissionGaurd>
        ),
      },
    ],
  },
  {
    path: 'clientQuotes',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <PermissionGaurd permission={PermissionCodes.ClientQuotes}>
            <ClientQuotes />
          </PermissionGaurd>
        ),
      },
      {
        path: 'add',
        element: (
          <PermissionGaurd permission={PermissionCodes.ClientQuotes}>
            <ClientQuotesAddEditForm />
          </PermissionGaurd>
        ),
      },
      {
        path: ':id/edit',
        element: (
          <PermissionGaurd permission={PermissionCodes.ClientQuotes}>
            <ClientQuotesAddEditForm />
          </PermissionGaurd>
        ),
      },
    ],
  },
  {
    path: 'countries',
    element: <AuthGuard><MainLayout /></AuthGuard>,
    children: [
      {
        path: '',
        element: (
          <PermissionGaurd permission={PermissionCodes.Country} right={PermissionRights.Search}>
            <CountrySearch />
          </PermissionGaurd>
        ),
      }
    ],
  },
  {
    path: 'translationSets',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <PermissionGaurd permission={PermissionCodes.TranslationSets}>
            <TranslationSets />
          </PermissionGaurd>
        ),
      },
      {
        path: ':id/edit',
        element: (
          <PermissionGaurd permission={PermissionCodes.TranslationSets}>
            <TranslationSetsEditForm />
          </PermissionGaurd>
        ),
      },
    ],
  },
  {
    path: 'dataSchemas',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <PermissionGaurd permission={PermissionCodes.DataSchema}>
            <DataSchemaSearch />
          </PermissionGaurd>
        ),
      },
      {
        path: ':id/edit',
        element: (
          <PermissionGaurd permission={PermissionCodes.DataSchema}>
            <DataSchemaSearchEditForm />
          </PermissionGaurd>
        ),
      },
    ],
  },
  {
    path: 'subscriptions',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <PermissionGaurd permission={PermissionCodes.Subscriptions}>
            <SubscriptionSearch />
          </PermissionGaurd>
        ),
      },
      {
        path: ':id/edit',
        element: (
          <PermissionGaurd permission={PermissionCodes.Subscriptions}>
            <SubscriptionSearchEditForm />
          </PermissionGaurd>
        ),
      },
    ],
  },
  {
    path: 'country',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: ':countryCode/edit',
        element: (
          <PermissionGaurd permission={PermissionCodes.Country} right={PermissionRights.Edit}>
            <CountryEdit />
          </PermissionGaurd>
        ),
      }
    ],
  },
  {
    path: 'userGroups',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <PermissionGaurd permission={PermissionCodes.UserGroups} right={PermissionRights.Search}>
            <UserGroupSearch />
          </PermissionGaurd>
        ),
      },
      {
        path: ':groupId/edit',
        element: (
          <PermissionGaurd permission={PermissionCodes.UserGroups} right={PermissionRights.Search}>
            <UserGroupDetails />
          </PermissionGaurd>
        ),
      },
    ],
  },
  {
    path: 'dashboard',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <PermissionGaurd extraPermissions={[PermissionCodes.DashboardSamples, PermissionCodes.DashboardOrders, PermissionCodes.DashboardBVOwned, PermissionCodes.DashboardClientOwned]} permission={PermissionCodes.Dashboard} right={PermissionRights.Search}>
            <DivisionSwitch
              divisionElementMap={[
                {
                  divisionId: Divisions.Minerals,
                  children: <MineralDashboard />,
                },
                { divisionId: Divisions.Food, children: <FoodDashboard /> },
                { divisionId: Divisions.Verifuel, children: <FQTDashboard /> },
                { divisionId: Divisions.BVAQ, children: <BVAQDashboard /> },
                { divisionId: Divisions.MaxxLIMs, children: <OPDashboard /> },
              ]}
            />
          </PermissionGaurd>
        ),
      },
      {
        path: 'um',
        element: (
          <PermissionGaurd permission={PermissionCodes.Dashboard}>
            <DivisionGaurd divisionId={Divisions.Minerals}>
              <MineralDashboard />
            </DivisionGaurd>
          </PermissionGaurd>
        ),
      },
      {
        path: 'food',
        element: (
          <PermissionGaurd permission={PermissionCodes.Dashboard}>
            <DivisionGaurd divisionId={Divisions.Food}>
              <FoodDashboard />
            </DivisionGaurd>
          </PermissionGaurd>
        ),
      },
      {
        path: 'vf',
        element: (
          <PermissionGaurd permission={PermissionCodes.Dashboard}>
            <DivisionGaurd divisionId={Divisions.Verifuel}>
              <FQTDashboard />
            </DivisionGaurd>
          </PermissionGaurd>
        ),
      },
      {
        path: 'petrohub',
        element: (
          <PermissionGaurd extraPermissions={[PermissionCodes.DashboardSamples, PermissionCodes.DashboardOrders, PermissionCodes.DashboardBVOwned, PermissionCodes.DashboardClientOwned]} permission={PermissionCodes.Dashboard} right={PermissionRights.Search}>
            <DivisionGaurd divisionId={Divisions.MaxxLIMs}>
              <OPDashboard />
            </DivisionGaurd>
          </PermissionGaurd>
        ),
      },
      {
        path: 'bvaq',
        element: (
          <PermissionGaurd permission={PermissionCodes.Dashboard}>
            <DivisionGaurd divisionId={Divisions.BVAQ}>
              <BVAQDashboard />
            </DivisionGaurd>
          </PermissionGaurd>
        ),
      },
    ],
  },
  {
    path: 'MyActions',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <PermissionGaurd permission={PermissionCodes.MyActions} right={PermissionRights.Edit}>
            <MyActions />
          </PermissionGaurd>
        ),
      },
    ],
  },
  {
    path: 'consumableOrders',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <PermissionGaurd permission={PermissionCodes.ConsumableOrders}>
            <ConsumableOrdersSearch />
          </PermissionGaurd>
        ),
      },
    ],
  },
  {
    path: 'consumableOrder',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {

        path: ':id/edit',
        element: (
          <PermissionGaurd permission={PermissionCodes.ConsumableOrders}>
            <ConsumableOrderEdit />
          </PermissionGaurd>
        )
      }, {
        path: 'add',
        element: (
          <PermissionGaurd permission={PermissionCodes.ConsumableOrders}>
            <ConsumableOrderAdd />

          </PermissionGaurd>
        ),
      },
    ],
  },
  {
    path: 'Orders',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <PermissionGaurd permission={PermissionCodes.Order} right={PermissionRights.Search}>
            <OrderSearch />
          </PermissionGaurd>
        ),
      },
      {
        path: ':id/view',
        element: (
          <PermissionGaurd permission={PermissionCodes.Order} right={PermissionRights.Search}>
            <OrderView />
          </PermissionGaurd>
        ),
      },
    ],
  },
  {
    path: 'OrderRequest',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <PermissionGaurd permission={PermissionCodes.OrderRequest} right={PermissionRights.Search}>
            <OrderRequestSearch />
          </PermissionGaurd>
        ),
      },
    ],
  },
  {
    path: 'OrderRequest',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: 'add',
        element: (
          <PermissionGaurd permission={PermissionCodes.OrderRequest} right={PermissionRights.Add}>
            <OrderRequestAdd />
          </PermissionGaurd>
        ),
      },
      {
        path: ':id/view',
        element: (
          <PermissionGaurd permission={PermissionCodes.OrderRequest} right={PermissionRights.Search}>
            <OrderRequestView />
          </PermissionGaurd>
        ),
      },
      {
        path: ':id/edit',
        element: (
          <PermissionGaurd permission={PermissionCodes.OrderRequest} right={PermissionRights.Edit}>
            <OrderRequestEdit />
          </PermissionGaurd>
        ),
      },
    ],
  },
  {
    path: 'apiLogs',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <PermissionGaurd permission={PermissionCodes.APILogs}>
            <APILogSearch />
          </PermissionGaurd>
        ),
      },
    ]
  },
  {
    path: 'outbounds',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <PermissionGaurd permission={PermissionCodes.Outbound}>
            <OutboundSearch />
          </PermissionGaurd>
        ),
      },
    ]
  },
  {
    path: 'KnowledgeCenter',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <PermissionGaurd permission={PermissionCodes.KnowledgeCenter} right={PermissionRights.Search}>
            <KnowledgeCenter />
          </PermissionGaurd>
        ),
      },
    ],
  },
  {
    path: 'configs',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <PermissionGaurd permission={PermissionCodes.ObjectConfigurations} right={PermissionRights.Search}>
            <ObjectConfigurationSearch />
          </PermissionGaurd>
        ),
      },
      {
        path: 'add',
        element: (
          <PermissionGaurd permission={PermissionCodes.ObjectConfigurations} right={PermissionRights.Add}>
            <ObjectConfigAddEditForm />
          </PermissionGaurd>
        ),
      },
      {
        path: ':id/edit',
        element: (
          <PermissionGaurd permission={PermissionCodes.ObjectConfigurations} right={PermissionRights.Edit}>
            <ObjectConfigAddEditForm />
          </PermissionGaurd>
        ),
      },
    ],
  },
  {
    path: 'clients',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <PermissionGaurd permission={PermissionCodes.Client} right={PermissionRights.Search}>
            <ClientPage />
          </PermissionGaurd>
        ),
      },
      // {
      //   path: 'Petrohub',
      //   element: (
      //     <PermissionGaurd permission={PermissionCodes.Client}>
      //       <PetrohubClientSearch />
      //     </PermissionGaurd>
      //   ),
      // },
      {
        path: ':id/edit',
        element: (
          <PermissionGaurd permission={PermissionCodes.Client} right={PermissionRights.Edit}>
            <PetrohubClientEdit />
          </PermissionGaurd>
        ),
      },
    ]
  },
  {
    path: '/inspectionLocations',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <PermissionGaurd permission={PermissionCodes.InspectionLocation}>
            <InspectionLocationSearch />
          </PermissionGaurd>
        ),
      },
      {
        path: 'add',
        element: (
          <PermissionGaurd permission={PermissionCodes.InspectionLocation}>
            <InspectionLocationAddEdit />
          </PermissionGaurd>
        ),
      },
      {
        path: ':id/edit',
        element: (
          <PermissionGaurd permission={PermissionCodes.InspectionLocation}>
            <InspectionLocationAddEdit />
          </PermissionGaurd>
        ),
      },
    ],
  },
  {
    path: 'account',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: <AccountSetting />,
      },
    ],
  },
  {
    path: 'Alerts',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <PermissionGaurd permission={PermissionCodes.Alerts}>
            <SampleAlertSearch />
          </PermissionGaurd>),
      },
    ],
  },
  {
    path: 'privacy',
    children: [
      {
        path: '',
        element: <LegalNotice />,
      },
      {
        path: '/privacy/legalnotice',
        element: <LegalNotice />,
      },
      {
        path: '/privacy/CookiesPolicy',
        element: <CookiesPolicy />,
      },
      {
        path: '/privacy/TermsOfUse',
        element: <TermsOfUse />,
      },
      {
        path: '/privacy/InformationNoticeToUser',
        element: <InformationNoticeToUser />,
      },
    ],
  },
  {
    path: 'experiment',
    element: <MainLayout />,
    children: [
      {
        path: '',
        element: <ExperimentFeature />,
      },
    ],
  },
  {
    path: 'trending',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <PermissionGaurd permission={PermissionCodes.Trending}>
            <TrendingView />
          </PermissionGaurd>
        ),
      },
    ],
  },
  // ------------------ AB (Actions)--------------------
  {
    path: 'actions',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <PermissionGaurd permission={PermissionCodes.Actions} right={PermissionRights.Search}>
            <ActionsSearch />
          </PermissionGaurd>
        ),
      }
    ],
  },
  {
    path: 'assets',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <PermissionGaurd permission={PermissionCodes.AssetManagement}>
            <AssetManagement />
          </PermissionGaurd>
        ),
      }
    ],
  },
  {
    path: 'equipments',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <PermissionGaurd permission={PermissionCodes.Equipments}>
            <Equipments />
          </PermissionGaurd>
        ),
      },
      // {
      //   path: 'add',
      //   element: (
      //     <PermissionGuard permission={PermissionCodes.Equipments} />
      //   ),
      // },
      // {
      //   path: ':id/edit',
      //   element: (
      //     <PermissionGuard permission={PermissionCodes.Equipments} />
      //   ),
      // },
    ],
  },
  {
    path: 'locations',
    children: [
      {
        path: '',
        element: (
          <Locations />
        ),
      }
    ],
  },
  //------------------------------------------
  {
    path: '*',
    children: [
      {
        path: '',
        exact: true,
        element: <Navigate to="/dashboard" />,
      },
      {
        path: 'login',
        element: <Login />,
      },
      {
        path: 'aboutUs',
        element: <AboutUs />,
      },
      {
        path: 'ForgotPassword',
        element: <ForgotPassword />,
      },
      {
        path: 'changepassword/:tokenId',
        element: <ClientPassword />,
      },
      {
        path: '401',
        element: <AuthorizationError />,
      },
      {
        path: '500',
        element: <ServerError />,
      },
      {
        path: '404',
        element: <NotFound />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
];

export default routes;
